import { Calendar, User, ArrowRight } from 'lucide-react';
import { Card } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { mockBlogPosts } from '@/data/mockData';
import { Link } from 'react-router-dom';
import { format } from 'date-fns';
import { fr } from 'date-fns/locale';

const categoryLabels = {
  'conseils-cv': 'CV & Lettres',
  'preparation-entretiens': 'Entretiens',
  'developpement-competences': 'Compétences',
  'portraits-talents': 'Portraits',
  'innovation-tech': 'Innovation & Tech'
};

const categoryColors = {
  'conseils-cv': 'bg-primary',
  'preparation-entretiens': 'bg-secondary',
  'developpement-competences': 'bg-success',
  'portraits-talents': 'bg-accent',
  'innovation-tech': 'bg-cyan-500'
};

export function BlogSection() {
  const latestPosts = mockBlogPosts.slice(0, 3);

  return (
    <section className="py-16 bg-background">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-poppins font-bold text-foreground mb-4">
            Conseils & Actualités
          </h2>
          <p className="text-lg text-muted-foreground font-inter max-w-2xl mx-auto">
            Des conseils pratiques et des histoires inspirantes pour booster votre carrière
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {latestPosts.map((post, index) => (
            <Card key={post.id} className="group bg-card hover-lift border border-border hover:border-primary transition-all overflow-hidden">
              {/* Cover Image */}
              <div className="relative h-56 bg-muted overflow-hidden">
                <div className="absolute inset-0 bg-gradient-to-br from-primary-light to-muted"></div>
                
                {/* Category Badge */}
                <div className={`absolute top-4 left-4 ${categoryColors[post.category]} text-white px-3 py-1 rounded-md text-xs font-semibold`}>
                  {categoryLabels[post.category]}
                </div>
                
                {/* Large Letter */}
                <div className="absolute inset-0 flex items-center justify-center">
                  <span className="text-9xl font-bold text-muted-foreground/10">
                    {post.title.charAt(0)}
                  </span>
                </div>
              </div>
              
              <div className="p-6">
                <h3 className="font-bold text-xl text-foreground mb-3 line-clamp-2 group-hover:text-primary transition-colors">
                  {post.title}
                </h3>
                
                <p className="text-muted-foreground font-inter text-sm mb-4 line-clamp-3 leading-relaxed">
                  {post.excerpt}
                </p>
                
                <div className="flex items-center justify-between text-sm text-muted-foreground mb-4">
                  <div className="flex items-center gap-2">
                    <User className="h-4 w-4" />
                    <span className="font-inter">{post.author}</span>
                  </div>
                  <div className="flex items-center gap-2">
                    <Calendar className="h-4 w-4" />
                    <span className="font-inter">
                      {format(post.publishedAt, 'dd MMM', { locale: fr })}
                    </span>
                  </div>
                </div>
                
                <Link to={`/blog/${post.slug}`}>
                  <Button variant="link" className="p-0 h-auto font-semibold">
                    Lire l'article
                    <ArrowRight className="ml-2 h-4 w-4" />
                  </Button>
                </Link>
              </div>
            </Card>
          ))}
        </div>
        
        <div className="text-center mt-10">
          <Link to="/blog">
            <Button variant="secondary" size="lg">
              Voir tous les articles
            </Button>
          </Link>
        </div>
      </div>
    </section>
  );
}